module.exports = [
  { "word": "people", "color": "#9FB59A" },
  { "word": "Queens", "color": "#86A4BF" },
  { "word": "time", "color": "#EED59B" },
  { "word": "years", "color": "#EED59B" },
  { "word": "school", "color": "#86A4BF" },
  { "word": "family", "color": "#F47D7D" },
  { "word": "work", "color": "#EED59B" },
  { "word": "neighborhood", "color": "#86A4BF" },
  { "word": "community", "color": "#86A4BF" },
  { "word": "moved", "color": "#EED59B" },
  { "word": "life", "color": "#EED59B" },
  { "word": "good", "color": "#9879A8" },
  { "word": "lived", "color": "#EED59B" },
  { "word": "father", "color": "#F47D7D" },
  { "word": "house", "color": "#86A4BF" },
  { "word": "started", "color": "#EED59B" },
  { "word": "New York City", "color": "#86A4BF" },
  { "word": "mother", "color": "#F47D7D" },
  { "word": "friends", "color": "#9FB59A" },
  { "word": "children", "color": "#F47D7D" },
  { "word": "parents", "color": "#F47D7D" },
  { "word": "wanted", "color": "#EED59B" },
  { "word": "living", "color": "#EED59B" },
  { "word": "worked", "color": "#EED59B" },
  { "word": "job", "color": "#EED59B" },
  { "word": "art", "color": "#9879A8" },
  { "word": "year", "color": "#EED59B" },
  { "word": "place", "color": "#86A4BF" },
  { "word": "live", "color": "#EED59B" },
  { "word": "working", "color": "#EED59B" },
  { "word": "Manhattan", "color": "#86A4BF" },
  { "word": "day", "color": "#EED59B" },
  { "word": "Long Island City", "color": "#86A4BF" },
  { "word": "Flushing", "color": "#86A4BF" },
  { "word": "kids", "color": "#F47D7D" },
  { "word": "high school", "color": "#EED59B" },
  { "word": "born", "color": "#EED59B" },
  { "word": "Fair", "color": "#86A4BF" },
  { "word": "Park", "color": "#86A4BF" },
  { "word": "kind", "color": "#9879A8" },
  { "word": "music", "color": "#9879A8" },
  { "word": "United", "color": "#86A4BF" },
  { "word": "money", "color": "#9879A8" },
  { "word": "area", "color": "#86A4BF" },
  { "word": "Astoria", "color": "#86A4BF" },
  { "word": "called", "color": "#EED59B" },
  { "word": "husband", "color": "#F47D7D" },
  { "word": "American", "color": "#ED9F58" },
  { "word": "Street", "color": "#86A4BF" },
  { "word": "city", "color": "#86A4BF" },
  { "word": "States", "color": "#86A4BF" },
  { "word": "big", "color": "#9879A8" },
  { "word": "Brooklyn", "color": "#86A4BF" },
  { "word": "college", "color": "#86A4BF" },
  { "word": "married", "color": "#EED59B" },
  { "word": "building", "color": "#86A4BF" },
  { "word": "love", "color": "#9879A8" },
  { "word": "College", "color": "#86A4BF" },
  { "word": "knew", "color": "#EED59B" },
  { "word": "great", "color": "#9879A8" },
  { "word": "met", "color": "#EED59B" },
  { "word": "feel", "color": "#EED59B" },
  { "word": "group", "color": "#9FB59A" },
  { "word": "English", "color": "#ED9F58" },
  { "word": "apartment", "color": "#86A4BF" },
  { "word": "School", "color": "#86A4BF" },
  { "word": "Avenue", "color": "#86A4BF" },
  { "word": "street", "color": "#86A4BF" },
  { "word": "young", "color": "#9FB59A" },
  { "word": "person", "color": "#9FB59A" },
  { "word": "thought", "color": "#9879A8" },
  { "word": "interview", "color": "#9879A8" },
  { "word": "food", "color": "#9879A8" },
  { "word": "country", "color": "#86A4BF" },
  { "word": "grew", "color": "#EED59B" },
  { "word": "Jackson Heights", "color": "#86A4BF" },
  { "word": "Jamaica", "color": "#86A4BF" },
  { "word": "Sunnyside", "color": "#86A4BF" },
  { "word": "changed", "color": "#EED59B" },
  { "word": "left", "color": "#EED59B" },
  { "word": "business", "color": "#86A4BF" },
  { "word": "days", "color": "#EED59B" },
  { "word": "change", "color": "#EED59B" },
  { "word": "experience", "color": "#EED59B" },
  { "word": "hard", "color": "#9879A8" },
  { "word": "America", "color": "#86A4BF" },
  { "word": "gay", "color": "#ED9F58" },
  { "word": "involved", "color": "#EED59B" },
  { "word": "friend", "color": "#9FB59A" },
  { "word": "small", "color": "#9879A8" },
  { "word": "sister", "color": "#F47D7D" },
  { "word": "brother", "color": "#F47D7D" },
  { "word": "felt", "color": "#9879A8" },
  { "word": "church", "color": "#86A4BF" },
  { "word": "child", "color": "#9FB59A" },
  { "word": "growing", "color": "#EED59B" },
  { "word": "public", "color": "#86A4BF" },
  { "word": "artist", "color": "#ED9F58"},
]
;